var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "17"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 16.387v-16h16v16z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M11.333 9.055H4.667V7.722h6.666zm0 2.667H4.667v-1.333h6.666zM4.667 5.055h4.666V6.39H4.667zm8.94.94-3.22-3.22a1.33 1.33 0 0 0-.94-.386H3.333C2.6 2.389 2 2.989 2 3.722v9.333c0 .734.6 1.334 1.333 1.334h9.334c.733 0 1.333-.6 1.333-1.334V6.942c0-.353-.14-.693-.393-.947"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }